exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expandable-title[data-v-92d273aa] {\n  cursor: pointer;\n  cursor: hand;\n}\n/*can't get this to work...*/\n.force-pointer > *[data-v-92d273aa] {\n  cursor: pointer;\n  cursor: hand;\n}\n", ""]);

// exports
